import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import socket from "../../assets/socketConnection";
import { setMapLevel } from "../../redux/map/map.actions";
import {
  selectNewRequestBargiryDate,
  selectNewRequestBargiryTime,
  selectNewRequestBarnameh,
  selectNewRequestBimeh,
  selectNewRequestDescBargiry,
  selectNewRequestDescTakhlieh,
  selectNewRequestDestLocation,
  selectNewRequestLoadDescLoad,
  selectNewRequestLoadValue,
  selectNewRequestLoadWeight,
  selectNewRequestSelectedVehicle,
  selectNewRequestSizes_height,
  selectNewRequestSizes_length,
  selectNewRequestSizes_width,
  selectNewRequestSourceLocation,
  selectNewRequestTakhliehTimeTo,
  selectNewRequestSelectedAuction,
  selectNewRequestSelectedLoadType,
  selectNewRequestSuggestionPrice,
  selectNewRequestTakhliehTime,
} from "../../redux/newRequest/newRequest.selectors";
import { SubmitReqRightColBtnsStyled } from "./submitReqRightColBtns.styles";

const SubmitReqRightColBtns = ({
  setMapLevel,
  loadDescLoad,
  loadTypes,
  bargiryTime,
  bargiryDate,
  bimeh,
  barnameh,
  loadValue,
  selectedVehicle,
  suggestionPrice,
  destLocation,
  sourceLocation,

  descTakhlieh,
  descBargiry,

  loadWeight,
  sizes_height,
  sizes_width,
  sizes_length,

  selectedAuction,

  takhliehTime,
  takhliehTimeTo,
  selectedLoadType,
}) => {
  // console.log(selectedLoadType);
  // debugger;
  const handle_cancel_click = () => {
    setMapLevel(0);
  };

  const handle_submit_click = () => {
    // alert("dhi");

    const finalData = {
      load_description: loadDescLoad,
      load_type: selectedLoadType,
      loading_date: bargiryDate.value,
      loading_time: `${bargiryTime._d.getHours()}:${bargiryTime._d.getMinutes()}`,
      request_barname: barnameh,
      request_insurance: bimeh,
      suggested_price: suggestionPrice,
      value: loadValue,
      vehicle_requested: selectedVehicle._id,
      vehicle_requested_type: selectedVehicle
        ? selectedVehicle.type[0]._id
        : "",

      source_location: sourceLocation,
      destination_location: destLocation,

      evacuation_description: descTakhlieh,
      loading_description: descBargiry,

      weight: loadWeight,
      weight_unit: "kl",
      length: sizes_length,
      width: sizes_width,
      height: sizes_height,

      auction_id: selectedAuction,

      evacuation_from: `${takhliehTime._d.getHours()}:${takhliehTime._d.getMinutes()}`,
      evacuation_to: `${takhliehTimeTo._d.getHours()}:${takhliehTimeTo._d.getMinutes()}`,

      // shown_support: "",
      // payment_in_destination: false,
      // request_model: 1,
      // request_type: "fast",
      // shown_tariff: {…},
    };

    // debugger;

    socket.emit("insert_new_load", finalData);
  };

  return (
    <SubmitReqRightColBtnsStyled>
      <button
        className="SubmitReqRightColBtnsStyled__btn"
        onClick={handle_cancel_click}
      >
        لغو
      </button>
      <button
        onClick={handle_submit_click}
        className="SubmitReqRightColBtnsStyled__btn SubmitReqRightColBtnsStyled__btn--yellow"
      >
        ثبت درخواست
      </button>
    </SubmitReqRightColBtnsStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  loadDescLoad: selectNewRequestLoadDescLoad,
  // loadType: selectnewloadtyp,

  bargiryTime: selectNewRequestBargiryTime,
  bargiryDate: selectNewRequestBargiryDate,

  barnameh: selectNewRequestBarnameh,
  bimeh: selectNewRequestBimeh,
  loadValue: selectNewRequestLoadValue,

  selectedVehicle: selectNewRequestSelectedVehicle,

  suggestionPrice: selectNewRequestSuggestionPrice,

  sourceLocation: selectNewRequestSourceLocation,
  destLocation: selectNewRequestDestLocation,

  descTakhlieh: selectNewRequestDescTakhlieh,
  descBargiry: selectNewRequestDescBargiry,

  loadWeight: selectNewRequestLoadWeight,
  sizes_height: selectNewRequestSizes_height,
  sizes_width: selectNewRequestSizes_width,
  sizes_length: selectNewRequestSizes_length,

  selectedAuction: selectNewRequestSelectedAuction,

  takhliehTimeTo: selectNewRequestTakhliehTimeTo,
  takhliehTime: selectNewRequestTakhliehTime,

  selectedLoadType: selectNewRequestSelectedLoadType,
});

const mapDispatchToProps = (dispatch) => ({
  setMapLevel: (x) => dispatch(setMapLevel(x)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmitReqRightColBtns);
